import type { helpWidgetItemOnViewNewSrc4Evid1505Params } from '@wix/bi-logger-customer-care-data/v2/types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { TRootState } from '../../common/reducers';
import { selectWidgetExpanded } from '../../common/selectors/widget';
import { reportItemOnViewWhenExpanded } from '../reportItemOnViewWhenExpanded';

export const useReportItemOnViewWhenExpanded = () => {
  const [isEventSent, setIsEventSent] = useState(false);
  const isWidgetExpanded = useSelector(selectWidgetExpanded);

  useEffect(() => {
    if (isWidgetExpanded) {
      setIsEventSent(false);
    }
  }, [isWidgetExpanded]);

  const report = React.useCallback(
    async (
      state: TRootState,
      params: Partial<helpWidgetItemOnViewNewSrc4Evid1505Params>,
    ): Promise<boolean> => {
      const sent = await reportItemOnViewWhenExpanded(state, params);
      if (sent) {
        setIsEventSent(true);
      }
      return sent;
    },
    [],
  );

  const markSent = React.useCallback(() => setIsEventSent(true), []);
  const resetSent = React.useCallback(() => setIsEventSent(false), []);

  return { report, isEventSent, markSent, resetSent, isWidgetExpanded };
};
